import { showErrorToast } from "../error-helpers/errorHelpers";

export default (err) => {
  showErrorToast(err?.message);
  return Promise.reject(err);
};
